import { render, staticRenderFns } from "./ImgValidator.vue?vue&type=template&id=33aea70b&scoped=true&"
import script from "./ImgValidator.vue?vue&type=script&lang=js&"
export * from "./ImgValidator.vue?vue&type=script&lang=js&"
import style0 from "./ImgValidator.vue?vue&type=style&index=0&id=33aea70b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33aea70b",
  null
  
)

export default component.exports